import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MaxBrainAudience } from 'app/library/audience/models/audience.model';
import { resolveAudienceFullPath } from '../utils/audience-display.util';

@Pipe({
    name: 'audienceFullPath',
    pure: false,
})
export class AudienceFullPathPipe implements PipeTransform {
    constructor(private _translateService: TranslateService) {}

    transform(audience: MaxBrainAudience | null | undefined): string {
        if (!audience) {
            return '';
        }

        return resolveAudienceFullPath(audience, (key) => this._translateService.instant(key));
    }
}
